import useMonolithApiMutation, { UseMonolithApiMutationOptions } from '@/hooks/api/useMonolithApiMutation';

// Only the fields we send; `organization#update` accepts a good deal more.
type Request = { aiFeatures: boolean; source?: string };

export const organizationUpdatePath = ({ workspaceSlug }: { workspaceSlug: string }) =>
  `/organization/${workspaceSlug}`;

const useOrganizationUpdate = (
  params: { workspaceSlug: string },
  opts?: UseMonolithApiMutationOptions<void, unknown, Request>,
) => useMonolithApiMutation<void, unknown, Request>(organizationUpdatePath(params), 'PUT', opts);

export default useOrganizationUpdate;
